import { render, staticRenderFns } from "./EventReportPage.vue?vue&type=template&id=133da0ea"
import script from "./EventReportPage.vue?vue&type=script&lang=js"
export * from "./EventReportPage.vue?vue&type=script&lang=js"
import style0 from "./EventReportPage.vue?vue&type=style&index=0&id=133da0ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports